import { CONFIG } from '../config';
import { type DOI } from '../utils/doi';

export function Publisher({ doi }: { doi: DOI }) {
  if (
    doi.publisher?.toLocaleLowerCase() !==
    CONFIG.SITE_PUBLISHER_NAME.toLocaleLowerCase()
  ) {
    return doi.publisher;
  }

  return (
    <a href={CONFIG.PUBLISHER_URL} target="_blank" rel="noopener noreferrer">
      {doi.publisher}
    </a>
  );
}
